// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LongTermPreviewPanel__container___6wvqT{bottom:20px;position:absolute;right:20px}", "",{"version":3,"sources":["webpack://./src/components/Taskbar/LongTermPreviewPanel/LongTermPreviewPanel.scss"],"names":[],"mappings":"AAAA,yCAEE,WADU,CAEV,iBAAA,CACA,UAHU","sourcesContent":[".container {\n  $spacing: 20px;\n  bottom: $spacing;\n  position: absolute;\n  right: $spacing;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "LongTermPreviewPanel__container___6wvqT"
};
export default ___CSS_LOADER_EXPORT___;
